import axios from 'axios';
import { StaffActionTypes } from './';

const endpoint = `${process.env.REACT_APP_EYS_API_HOST}/api/Staff`;

export function findStaffs() {
  const request = axios.get(`${endpoint}?page=1&perPage=1000000`);
  return {
    type: StaffActionTypes.FIND,
    payload: request
  };
}



// WEBPACK FOOTER //
// ./src/actions/staff.action.js